<template>
  <v-expansion-panels
    class="form-panels"
    accordion
    v-model="panel"
    multiple
    :readonly="readonly"
  >
    <slot></slot>
  </v-expansion-panels>
</template>

<script>
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // Only actual FormPanel components register with v-expansion-panels
    // (v-if placeholders / whitespace text nodes don't), so the model
    // index must be based on that filtered, registration-order list.
    const panels = this.$slots.default.filter((vnode) => vnode.componentOptions);
    const panel = panels
      .map((vnode, i) => {
        // A bare boolean attribute (e.g. `closed-by-default`, no `v-bind`)
        // is passed through as propsData.closedByDefault === "" (an empty
        // string), which is falsy in JS — so check for presence, not truthiness.
        const value = vnode.componentOptions.propsData?.closedByDefault;
        const closed = value !== undefined && value !== false;
        return closed ? -1 : i;
      })
      .filter((i) => i !== -1);

    return {
      panel,
    };
  },
  created() {},
};
</script>

<style scoped lang="scss">
.form-panels {
  margin-top: 30px;
  border: 2px solid var(--v-border-base);
  position: static !important;
}

.form-panels::v-deep .form-panel:last-child .v-expansion-panel-content {
  border-bottom: none !important;
}
</style>
